/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:02/07/2021
 @Time:08:23
 **/
import "jquery-countdown/dist/jquery.countdown";
$(function(){
     $(".countdown").each(function(index,element){
         $(this).countdown($(this).data("countdown-date"),
             function(event) {
             let countdown=$(this);
             countdown.find(".days .countdown-value").text(event.strftime('%D'));
             countdown.find(".hours .countdown-value").text(event.strftime('%H'));
             countdown.find(".minutes .countdown-value").text(event.strftime('%M'));
             countdown.find(".seconds .countdown-value").text(event.strftime('%S'));
          });
    });
});